import { __awaiter, __decorate } from 'tslib';
import { Input, Component, NgModule } from '@angular/core';
import * as ClipboardWeb from 'clipboard/dist/clipboard.min.js';
import { ToastController, IonicModule } from '@ionic/angular';
import { Clipboard } from '@ionic-native/clipboard/ngx';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { QRCodeModule } from 'angularx-qrcode';

let UiCUserAccountInfoComponent = class UiCUserAccountInfoComponent {
    constructor(toastCtrl, clipboardApp) {
        this.toastCtrl = toastCtrl;
        this.clipboardApp = clipboardApp;
        this.clipboardWeb = new ClipboardWeb('#cpyBtn');
        this.clipboardWeb.on('success', () => {
            this.toastCopy();
        });
    }
    copyAccountData() {
        this.clipboardApp.copy(this.qrCodeValue);
        this.toastCopy();
    }
    ngOnInit() {
        this.generateQrCode();
    }
    ngOnChanges() {
        this.generateQrCode();
    }
    generateQrCode() {
        this.qrCodeValue = `DADOS DA CONTA
    Nome: ${this.userProfile ? this.userProfile.fullName : ''}
    CPF/CNPJ: ${this.userProfile ? this.userProfile.documentDefault : ''}
    Banco: ${this.userProfile ? this.userProfile.codeBank : ''} - ${this.userProfile ? this.userProfile.nameBank : ''}
    Agência: ${this.userProfile ? this.userProfile.agencyBank : ''}
    Conta de Pagamento: ${this.userProfile ? this.formatAccount(this.userProfile.numberAccountBank) : ''}`;
    }
    toastCopy() {
        return __awaiter(this, void 0, void 0, function* () {
            const toast = yield this.toastCtrl.create({
                message: 'Dados copiados com sucesso.',
                duration: 2000,
                buttons: [
                    {
                        text: 'Fechar',
                        role: 'cancel',
                        handler: () => { },
                    },
                ],
            });
            toast.present();
        });
    }
    formatAccount(account) {
        if (String(account).length > 1) {
            return String(account).replace(/(\d+)(\d{1})/, '$1-$2');
        }
        else {
            return account;
        }
    }
};
UiCUserAccountInfoComponent.ctorParameters = () => [
    { type: ToastController },
    { type: Clipboard }
];
__decorate([
    Input()
], UiCUserAccountInfoComponent.prototype, "userProfile", void 0);
__decorate([
    Input()
], UiCUserAccountInfoComponent.prototype, "qrCodeData", void 0);
UiCUserAccountInfoComponent = __decorate([
    Component({
        selector: 'ui-c-user-account-info',
        template: "<div class=\"ui-c-user-account-info\">\n  <div class=\"qr-code-container\">\n    <qrcode\n      [qrdata]=\"qrCodeValue\"\n      [margin]=\"0\"\n      [errorCorrectionLevel]=\"'M'\"\n      [cssClass]=\"qrCodeData.class\"\n      [colorDark]=\"qrCodeData.colorDark\"\n      [colorLight]=\"qrCodeData.colorLight\"\n      [width]=\"qrCodeData.width\"\n    ></qrcode>\n  </div>\n  <div class=\"account-info-outer\">\n    <div class=\"account-info-container\" id=\"copyTarget\">\n      <p class=\"font-weight-bold box-left-text\">{{ userProfile?.fullName }}</p>\n      <p class=\"box-left-text\">{{ ' CPF/CNPJ: ' + userProfile?.documentDefault }}</p>\n      <p class=\"box-left-text\">Banco: {{ userProfile?.codeBank }} - {{ userProfile?.nameBank }}</p>\n      <p class=\"box-left-text\">\n        Ag\u00EAncia: {{ userProfile?.agencyBank }} | Conta de Pagamento: {{ formatAccount(userProfile?.numberAccountBank) }}\n      </p>\n    </div>\n    <div class=\"copy-button button-box\" (click)=\"copyAccountData()\" id=\"cpyBtn\" data-clipboard-target=\"#copyTarget\">\n      <ion-icon class=\"center-content icon-copy icon-size\" name=\"copy-outline\"></ion-icon>\n      <p class=\"text-center font-weight-bold\">copiar</p>\n    </div>\n  </div>\n</div>\n"
    })
], UiCUserAccountInfoComponent);

let UiCUserAccountInfoModule = class UiCUserAccountInfoModule {
};
UiCUserAccountInfoModule = __decorate([
    NgModule({
        declarations: [
            UiCUserAccountInfoComponent
        ],
        imports: [
            ReactiveFormsModule,
            CommonModule,
            IonicModule,
            QRCodeModule,
        ],
        providers: [
            Clipboard
        ],
        exports: [
            UiCUserAccountInfoComponent
        ]
    })
], UiCUserAccountInfoModule);

/*
 * Public API Surface of ui-c-user-account-info
 */

/**
 * Generated bundle index. Do not edit.
 */

export { UiCUserAccountInfoComponent, UiCUserAccountInfoModule };
//# sourceMappingURL=wlp-ui-c-user-account-info.js.map
